export default __webpack_public_path__ + "2ba9a4b8d4fcdb41c9412695928683ed.obj";